import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import {
  ImagePlacementVariants,
  LatestBlogPostsCarouselInterface,
} from 'common/types/entities/LatestBlogPostsCarouselInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createLatestBlogPostsCarousel(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): LatestBlogPostsCarouselInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.LatestBlogPostsCarousel,
      parentId,
      masterBlockId,
    ),
    imagePlacement: ImagePlacementVariants.Left,
    columnsGap: 30,
    maxPostsPerRow: 1,
    maxPosts: 5,
    showArrows: true,
    controlsColor: 'rgba(0, 0, 0, 1)',
    arrowsColor: 'rgba(0, 0, 0, 1)',
    showDate: false,
    titleFontSize: 26,
    mobileTitleFontSize: 22,
    titleColor: 'rgba(20, 45, 99, 1)',
    titleAlign: 'left',
    categoriesFontSize: 18,
    categoriesColor: 'rgba(27, 160, 255, 1)',
    categoriesAlign: 'left',
    descriptionFontSize: 22,
    mobileDescriptionFontSize: 18,
    descriptionColor: 'rgba(100, 101, 126, 1)',
    descriptionAlign: 'left',
    dateFontSize: 18,
    dateColor: 'rgba(20, 45, 99, 1)',
    dateAlign: 'left',
    padding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    postsReplacement: '%BLOG_LATEST_POSTS%',
    imageMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    titleMargin: {
      marginTop: 5,
      marginRight: 0,
      marginBottom: 5,
      marginLeft: 10,
    },
    categoriesMargin: {
      marginTop: 5,
      marginRight: 0,
      marginBottom: 5,
      marginLeft: 10,
    },
    descriptionMargin: {
      marginTop: 5,
      marginRight: 0,
      marginBottom: 5,
      marginLeft: 10,
    },
    dateMargin: {
      marginTop: 10,
      marginRight: 0,
      marginBottom: 10,
      marginLeft: 10,
    },
    mobileImageMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileTitleMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 5,
    },
    mobileCategoriesMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 5,
    },
    mobileDescriptionMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 5,
    },
    mobileDateMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 5,
    },
  }
}
